/**
 * Sanitizes text input to prevent XSS attacks and remove potentially harmful content
 * @param text - The text to sanitize
 * @returns Sanitized text safe for display
 */
export const sanitizeText = (text: string): string => {
  return (
    text
      .trim()
      // Remove potentially harmful HTML tags and scripts
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
      .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "")
      .replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, "")
      .replace(/<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi, "")
      .replace(/<link\b[^>]*>/gi, "")
      .replace(/<meta\b[^>]*>/gi, "")
      .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "")
      // Remove javascript: and data: URLs
      .replace(/javascript:/gi, "")
      .replace(/data:/gi, "")
      // Remove on* event handlers
      .replace(/\son\w+\s*=\s*["'][^"']*["']/gi, "")
      // Basic XSS prevention - escape common characters
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#x27;")
      .replace(/\//g, "&#x2F;")
  )
}
